import { Control, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Skeleton, TextFieldProps } from '@mui/material';

import BaseTextField from '../../../../core/presentation/components/base-text-field/base-text-field';

export type AddressTextFieldProps = TextFieldProps & {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any>;
  errorText?: string;
  isLoading?: boolean;
};

const AddressTextField = (props: AddressTextFieldProps) => {
  const { t } = useTranslation(['components']);
  return (
    <Controller
      name='address'
      control={props.control}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <div>
          {props.isLoading ? (
            <Skeleton variant='rectangular' height={56} />
          ) : (
            <BaseTextField
              onChange={onChange}
              value={value || ''}
              error={!!error}
              helperText={
                error ? props.errorText ?? t('addressInvalid') : undefined
              }
              id='address'
              name='address'
              label={t('address')}
              variant='filled'
              type='address'
              inputProps={{ maxLength: 256 }}
              required
              {...props}
            />
          )}
        </div>
      )}
    />
  );
};

export default AddressTextField;
